export default {
  ArrowLeft: 1,
  ArrowUp: 2,
  ArrowRight: 3,
  ArrowDown: 4,
};
